import React from 'react';
import { Quote } from 'lucide-react';

const Testimonial = ({ 
  quote = 'ISOcore has transformed how we manage our ISO certifications. The platform is intuitive and saves us countless hours.',
  author = 'John Smith',
  role = 'Quality Manager',
  company = 'Acme Corporation',
  avatar = '',
  className = '' 
}) => {
  return (
    <div className={`bg-card border border-border rounded-lg p-8 ${className}`}>
      <Quote className="w-10 h-10 text-primary/20 mb-4" />
      <blockquote className="text-lg mb-6">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-4">
        {avatar ? (
          <img 
            src={avatar} 
            alt={author} 
            className="w-12 h-12 rounded-full object-cover"
          />
        ) : (
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
            <span className="text-primary font-semibold">
              {author.charAt(0)}
            </span>
          </div>
        )}
        <div>
          <div className="font-semibold">{author}</div>
          <div className="text-sm text-muted-foreground">
            {role}, {company}
          </div>
        </div>
      </div>
    </div>
  );
};

Testimonial.builderConfig = {
  props: {
    quote: {
      type: 'textarea',
      label: 'Quote',
      default: 'ISOcore has transformed how we manage our ISO certifications. The platform is intuitive and saves us countless hours.',
    },
    author: {
      type: 'text',
      label: 'Author Name',
      default: 'John Smith',
    },
    role: {
      type: 'text',
      label: 'Role',
      default: 'Quality Manager',
    },
    company: {
      type: 'text',
      label: 'Company',
      default: 'Acme Corporation',
    },
    avatar: {
      type: 'image',
      label: 'Avatar Image',
      default: '',
    },
  },
};

export default Testimonial;
